import { BFFAgent } from '../../BFFAgent'
import { getPeritajeForPresupuestador } from '../BFF_peritador/getPeritajeForPresupuestador'

 // Era 0.96  -----  Se baja un 4% para considerar posibles gastos
const MULTIPLICADOR_COTIZACION = 1

export async function getCotizacionForPresupuestador(params) {
  const peritaje = await getPeritajeForPresupuestador(params.patente).catch((error) => {
    console.log('No se encontró peritaje con esa patente. Buscando cotizacion...')
    return null
  })
  if (peritaje) {
    return peritaje
  } else {
    const cotizacion = await BFFAgent.Cotizador.getCotizacion(params)
    const precioEstimado = cotizacion.quote.prices.filter((price) => price.type === 'estimated')
    const result = {
      ...params,
      precio: precioEstimado[0].amount * MULTIPLICADOR_COTIZACION,
      cotizacionId: cotizacion.id,
    }

    return result
  }
}
